import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { Box, CircularProgress, CssBaseline, TextField } from "@mui/material";
import MetaDecorator from "../../services/meta_decorator";
import NDReferralHeader from "../../components/shared/ndreferralheader";
import { getApiUrl } from "../../services/api_service";
import Footer from "../../components/shared/footer";
import { bodyBg, footerContainer, fullHeight, pcolor, rcolor, whitecolor } from "../../style2";

export default function UpdateAccount() {
    const { orgCode } = useParams();

    const [name, setName] = useState('');
    const [organizationName, setOrganizationName] = useState('');
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [redirect, setRedirect] = useState('');
    const [isLoggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        setLoading(true);
        fetch(getApiUrl() + "/ReferrerAccount/istokenvalid?user=true", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        }).then(resp => {
            if (resp.status === 200) {
                resp.json().then(data => {
                    setLoggedIn(true);
                    setName(data.name);
                    setTitle(data.title);
                    setOrganizationName(data.organizationName);
                })
            } else {
                setRedirect(`/referral/login/${orgCode}`);
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }, [orgCode]);

    const updateFunc = () => {
        const authTokens = localStorage.getItem("authTokens");
        let token;

        if (authTokens) {
            const parsedAuthTokens = JSON.parse(authTokens);
            token = parsedAuthTokens?.accessToken;
        }
        if (!token) {
            return;
        }
        setError('');
        setSuccess('');
        setLoading(true);
        fetch(getApiUrl() + "/ReferrerAccount/update", {
            method: "post",
            body: JSON.stringify({ name, title, organization: organizationName }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }).then(resp => {
            if (resp.status === 200) {
                setSuccess("Account information updated successfully");
            }
            else if (resp.status === 401 || resp.status === 403) {
                localStorage.clear();
                setRedirect(`/referral/login/${orgCode}`);
            }
            else {
                resp.json().then(data => {
                    setError(data.error);
                    console.log(data);
                }).catch(err => {
                    setError("Unable to process the request.");
                    console.log(err);
                });
            }
        }).catch(err => {
            setError('Unable to contact server. Check your internet connection.');
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    }

    if (redirect !== "")
        return <Redirect to={redirect} />
    else
        return <Box sx={{ ...bodyBg, ...fullHeight }}>
            <CssBaseline />
            <MetaDecorator title={"EnrichMyCare - Make A Referral"} description={"EnrichMycare Make Refferal"} />
            <NDReferralHeader date={Date.UTC()} isLoggedIn={isLoggedIn} orgCode={orgCode} logo="../../Logo_Option_1.svg" />
            <Box sx={{ width: "50%", padding: "5rem 10rem", margin: "0 auto" }}>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    updateFunc();
                }}>

                    <Box mb={1}>
                        <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Name *</label>
                        <TextField inputProps={{ maxLength: "50" }} style={{
                            border: `1px solid ${pcolor}`, borderRadius: 5,
                            width: "100%"
                        }} variant="outlined" required={true} label="" value={name} onChange={(e) => {
                            setName(e.target.value);
                        }} />
                    </Box>
                    <Box mb={1}>
                        <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Title</label>
                        <TextField inputProps={{ maxLength: "50" }} style={{
                            border: `1px solid ${pcolor}`, borderRadius: 5,
                            width: "100%"
                        }} variant="outlined" label="" value={title} onChange={(e) => {
                            setTitle(e.target.value);
                        }} />
                    </Box>
                    <Box mb={1}>
                        <label style={{ color: pcolor, display: "block", fontSize: "1.1rem", marginBottom: "10px" }}>Organisation *</label>
                        <TextField inputProps={{ maxLength: "190" }} style={{
                            border: `1px solid ${pcolor}`, borderRadius: 5,
                            width: "100%"
                        }} variant="outlined" required={true} label="" value={organizationName} onChange={(e) => {
                            setOrganizationName(e.target.value);
                        }} />
                    </Box>
                    <Box py={2} textAlign="center">
                        <button type="submit" disabled={loading}
                            style={{
                                border: `1px solid ${rcolor}`, background: `${rcolor}`, color: `${whitecolor}`, fontSize: "1.5rem",
                                height: "50px", width: "444px", borderRadius: 2
                            }}>{loading ? <CircularProgress size={20} /> : null} Update</button>
                    </Box>
                    {error !== "" ? <Box mt={1} mb={2} sx={{ color: `${rcolor}`, fontSize: "1.1rem", textAlign: "center" }}>{error}</Box> : null}
                    {success !== "" ? <Box mt={1} mb={2} sx={{ color: "green", fontSize: "1.1rem", textAlign: "center" }}>{success}</Box> : null}
                </form>
            </Box>
            <Box sx={footerContainer}>
                <Footer />
            </Box>
        </Box>;
}